import {createSelector} from 'reselect';
import {IGlobalStore} from 'modules/types';


export const isPPJsonsFetched = createSelector(
	[(state: IGlobalStore) => state.jsons_state],
	(state) => state.jsons_fetched
);
